
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CountryOption } from "@/types/visa";

interface VisaSelectorProps {
  selectedCountry: string;
  selectedVisaType: string;
  travelingFrom: string;
  onCountryChange: (value: string) => void;
  onVisaTypeChange: (value: string) => void;
  onTravelingFromChange: (value: string) => void;
  countries: CountryOption[];
  visaTypes: CountryOption[];
  originCountries: CountryOption[];
}

const VisaSelector = ({
  selectedCountry,
  selectedVisaType,
  travelingFrom,
  onCountryChange,
  onVisaTypeChange,
  onTravelingFromChange,
  countries,
  visaTypes,
  originCountries,
}: VisaSelectorProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12 border rounded-lg p-4 md:p-6 bg-white shadow-sm">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Destination Country
        </label>
        <Select value={selectedCountry} onValueChange={onCountryChange}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Choose a country" />
          </SelectTrigger>
          <SelectContent>
            {countries.map((country) => (
              <SelectItem key={country.value} value={country.value}>
                {country.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Visa Type
        </label>
        <Select value={selectedVisaType} onValueChange={onVisaTypeChange}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select a visa type" />
          </SelectTrigger>
          <SelectContent>
            {visaTypes.map((type) => (
              <SelectItem key={type.value} value={type.value}>
                {type.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Traveling From
        </label>
        <Select value={travelingFrom} onValueChange={onTravelingFromChange}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select your country of residence" />
          </SelectTrigger>
          <SelectContent>
            {originCountries.map((country) => (
              <SelectItem key={country.value} value={country.value}>
                {country.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <p className="text-xs text-gray-500 mt-1">
          This helps us provide country-specific visa information.
        </p>
      </div>
    </div>
  );
};

export default VisaSelector;
